module.exports = __webpack_public_path__ + "media/images/japan/location_2-791fbc4e517ac6e7c87fd2a3622cf837.png";